import { render, staticRenderFns } from "./OrderItemPreview.vue?vue&type=template&id=70d66384&"
import script from "./OrderItemPreview.vue?vue&type=script&lang=ts&"
export * from "./OrderItemPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports